export default {
  namespaced: true,
  state: {
    labelText: '卫宁招聘'
  },
  actions: {

  },
  mutations: {    
    setLabelText(state, text){
      state.labelText = text
    }
  }
}